import React from 'react';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';
import { ExclamationCircleOutlined, LinkOutlined } from '@ant-design/icons';

/**
 * مسیر داخلی پنل بر اساس type + id
 * (url بک‌اند نادیده گرفته می‌شود چون دامنه CRM قدیمی را برمی‌گرداند)
 */
export const resolveDuplicateEntityPath = (info) => {
  const id = info?.id;
  if (id == null || id === '') return null;

  const type = String(info?.type || '')
    .trim()
    .toLowerCase();

  if (type === 'lead' || type === 'lead_contact' || type === 'lead-contact') {
    return `/leads/${id}`;
  }
  if (type === 'client' || type === 'customer') {
    return `/clients/${id}`;
  }
  if (type === 'deal') {
    return `/deals/${id}`;
  }
  return null;
};

/** هشدار مینیمال تکراری بودن شماره — زیر فیلد موبایل/شماره دوم */
const PhoneDuplicateAlert = ({ info, loading }) => {
  if (loading && !info) {
    return (
      <span className="mt-0.5 text-[11px] leading-snug text-slate-400 custom-font inline-flex items-center gap-1">
        <Spin size="small" className="scale-75 origin-center" />
        در حال بررسی شماره...
      </span>
    );
  }

  if (!info?.exists) return null;

  const viewPath = resolveDuplicateEntityPath(info);
  const text = info.message || 'این شماره قبلاً ثبت شده است.';

  return (
    <span className="mt-0.5 text-[11px] leading-snug text-amber-700 dark:text-amber-400 custom-font inline-flex flex-wrap items-center gap-x-1.5 gap-y-0.5">
      <ExclamationCircleOutlined className="text-[10px] shrink-0" />
      <span>{text}</span>
      {viewPath ? (
        <Link
          to={viewPath}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-0.5 text-indigo-600 dark:text-indigo-400 hover:underline whitespace-nowrap"
        >
          <LinkOutlined className="text-[10px]" />
          مشاهده پرونده
          {info.type_label ? ` (${info.type_label})` : ''}
        </Link>
      ) : null}
    </span>
  );
};

export default PhoneDuplicateAlert;
